/* eslint-disable no-unused-vars */
const minWidth = 89;
const maxWidth = 110;
const widthInSmallScreen = 48;
export const UNQIndexStyle = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '.unified-notification-queue-container': {

    '@media only screen and (max-width:1023px)': {
      '&.unified-notification-queue-container': {
        minWidth: `${widthInSmallScreen}px !important`,

        '& .unified-notification-queue': {
          minWidth: `${widthInSmallScreen}px !important`,
        },

        '& .unified-notification-queue-trigger-btn': {
          minWidth: `${widthInSmallScreen}px !important`,
        },

        '& .alert-icon': {
          minWidth: `${widthInSmallScreen}px !important`,
          fontSize: '20px !important',
        },

        '& .alert-icon:before': {
          position: 'relative !important',
          top: '2px !important',
          right: '0 !important',
        },

        '& .notification-bell-active:after': {
          fontSize: '16px !important',
        },

        '& .unified-notification-queue-trigger-text': {
          display: 'none',
        },
      },
    },

    position: 'relative',
    minWidth,
    maxWidth,
    height: '60px',

    '& .unified-notification-queue': {
      minWidth,
      maxWidth,
      height: '60px',

      '& .unified-notification-queue-trigger-btn': {
        minWidth,
        maxWidth,
        height: '60px',
        border: 0,
        borderRadius: 0,
        padding: 0,
        outline: 'none',
        backgroundColor: '#2F2F2F',
        color: '#FFFFFF',
        fontWeight: 'normal',

        '& >div': {
          display: 'flex',
          flexDirection: 'column',
          pointerEvents: 'none',
        },

        '& .alert-icon': {
          minWidth,
          maxWidth,
          fontFamily: iconFontFamily,
          fontSize: 16,
          lineHeight: '16px',
          paddingBottom: 6,
          textAlign: 'center',
          position: 'relative',
          top: 2,
        },

        '& .alert-icon:before': {
          content: '"\\EA8F"',
        },

        '& .notification-bell-active:after': {
          content: '"\\ECCC"',
          color: '#D83B01',
          fontSize: 14,
          width: 10,
          position: 'absolute',
          marginLeft: -12,
          marginTop: -6,
          height: '10px',
        },

        '& .unified-notification-queue-trigger-text': {
          minWidth,
          maxWidth,
          textAlign: 'center',
          lineHeight: '14px',
          color: '#FFFFFF',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          padding: '0 2px',
        },
      },

      '& .unified-notification-queue-trigger-btn:hover': {
        background: '#106ebe',
        color: '#ffffff',
      },

      '& .unified-notification-queue-trigger-btn:focus:after': {
        border: 'none',
        right: '1px',
        top: '1px',
      },

      '& .unified-notification-queue-trigger-btn:active, & .unified-notification-queue-trigger-btn:focus': {
        background: '#ffffff',
        color: '#323130',

        '& .unified-notification-queue-trigger-text': {
          color: '#323130',
        },
      },

      '& .bingads-popover': {
        position: 'fixed !important',
        left: 'auto !important',
        right: 0,
        top: '60px !important',
        width: 460,
        height: 'calc(100vh - 60px)',
        minHeight: '350px',
        boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
        border: 0,
        background: '#FAF9F8',
      },

      '& .preview-bar': {
        position: 'absolute',
        top: 60,
        right: 0,
        height: '45px',
        width: 368,
        backgroundColor: '#FAF9F8',
        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.22)',
        border: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',

        '& .alert-queue-icon': {
          margin: '0px 12px 0px 0px',
        },

        '& .alert-queue-icon:first-child': {
          margin: '0px 12px 0px 16px',
        },

        '& .preview-bar-content': {
          fontWeight: 'normal',
          marginRight: 12,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: '#333333',
          lineHeight: '22px',
          height: '22px',
        },

        // title of first notification in multi-item preview bar
        '& .preview-bar-content-multi-item:nth-child(2)': {
          maxWidth: 160,
          flexShrink: 0,
        },

        '& .preview-bar-view-more': {
          padding: 0,
          marginRight: 12,
          color: '#0078D4',
          lineHeight: '22px',
          height: '22px',
          textAlign: 'left',
          flexShrink: 0,
        },

        '& .dismiss': {
          margin: '0px 15px 0px auto',
          minWidth: 12,
          right: 0,
        },
      },

      '& .alert-queue-icon': {
        display: 'block',
        width: 20,
        height: '22px',
        fontSize: 20,
        fontFamily: iconFontFamily,
        lineHeight: '22px',
      },

      '& .alert-queue-icon-critical': {
        color: '#A80000',
      },

      '& .alert-queue-icon-critical:before': {
        content: '"\\E783"',
      },

      '& .alert-queue-icon-warning': {
        color: '#BE5A00',
      },

      '& .alert-queue-icon-warning:before': {
        content: '"\\E7BA"',
      },

      '& .alert-queue-icon-opportunity': {
        color: '#0078D4',
      },

      '& .alert-queue-icon-opportunity:before': {
        content: '"\\E3AF"',
      },

      '& .alert-queue-icon-info': {
        color: '#605E5C',
      },

      '& .alert-queue-icon-info:before': {
        content: '"\\E946"',
      },

      '& .dismiss': {
        width: 12,
        height: '12px',
        opacity: 1,
        color: '#605E5C',
        fontSize: 12,
        lineHeight: '12px',
        fontFamily: iconFontFamily,
      },

      '& .dismiss:before': {
        content: '"\\E711"',
      },

      '& .jump-out-icon': {
        display: 'inline-block',
        fontFamily: iconFontFamily,
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        lineHeight: 1,
        position: 'relative',
        paddingLeft: 4,
      },

      '& .jump-out-icon::before': {
        content: '"\\E8A7"',
      },

      '& .notification-queue-loading-panel': {
        width: '100%',
        justifyContent: 'center',
        border: 0,
        padding: '37px 26px 5px',
        display: 'block',

        // hide unwanted redundant loading icon in CCUI
        '& .blocker-indicator': {
          position: 'static',
          padding: 0,

          '&:before': {
            display: 'none',
          },
        },

        '& .blocker-text': {
          position: 'absolute',
          top: 246,
          left: 184,
          color: '#007DAA',
          fontSize: 12,
          lineHeight: '16px',
          textAlign: 'center',
          width: 72,
        },
      },

      '& a:link, a:visited, a:hover, a:active': {
        textDecoration: 'none',
        outline: 'none',
      },

      '& button': {
        background: 'transparent',
        boxShadow: 'none',
        border: 0,
        padding: 0,
        textDecoration: 'none',
        outline: 'none',
      },
    },
  },
});
